function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M6.99996 8.16882C10.2623 8.16882 12.8166 4.72469 12.9238 4.57804C13.0254 4.43906 13.0254 4.25022 12.9238 4.11112C12.7494 3.98886 12.3407 3.86434 12.1004 4.34437C11.484 5.09208 9.40287 7.37762 6.99996 7.37762C4.59177 7.37762 2.51484 5.09287 1.89954 4.34491C1.65916 3.86531 1.25046 3.98929 1.07615 4.11123C0.974617 4.25036 0.974617 4.43906 1.07615 4.57818C1.18324 4.72469 3.73765 8.16882 6.99996 8.16882Z",
  fill: "#789EFF",
  stroke: "#789EFF",
  strokeWidth: 0.3
});

var _ref3 = /*#__PURE__*/React.createElement("path", {
  d: "M3 6.18524L1.74621 7.34445",
  stroke: "#789EFF",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

var _ref4 = /*#__PURE__*/React.createElement("path", {
  d: "M6.72409 7.94454L6.72339 9.44446",
  stroke: "#789EFF",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

var _ref5 = /*#__PURE__*/React.createElement("path", {
  d: "M4.78228 7.42928L4.0001 9.08311",
  stroke: "#789EFF",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

var _ref6 = /*#__PURE__*/React.createElement("path", {
  d: "M11.2 6.32611L12.1 7.22611",
  stroke: "#789EFF",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

var _ref7 = /*#__PURE__*/React.createElement("path", {
  d: "M9 7.68524L9.77482 8.81406",
  stroke: "#789EFF",
  strokeWidth: 1.2,
  strokeLinecap: "round"
});

function SvgEyeClose(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, ["title", "titleId"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ref2, _ref3, _ref4, _ref5, _ref6, _ref7);
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgEyeClose);
export default __webpack_public_path__ + "static/media/eye-close.9fb81c33.svg";
export { ForwardRef as ReactComponent };